const getDay = function(timeInMinutes) {
	if (timeInMinutes < 1440) {
		return 'Sunday';
	} else if (timeInMinutes < 2880) {
		return 'Monday';
	} else if (timeInMinutes < 4320) {
		return 'Tuesday';
	} else if (timeInMinutes < 5760) {
		return 'Wednesday';
	} else if (timeInMinutes < 7200) {
		return 'Thursday';
	} else if (timeInMinutes < 8640) {
		return 'Friday';
	} else {
		return 'Saturday';
	}
};



const getHours = function(timeInMinutes, formatted = true) {
	const hourOfTheDay = Math.floor(timeInMinutes % 1440 / 60);
	if (formatted) {
		const calculatedHour = hourOfTheDay < 12 ? hourOfTheDay : hourOfTheDay - 12;
		return calculatedHour === 0 ? 12 : calculatedHour;
	}
	return (hourOfTheDay < 12 ? hourOfTheDay : hourOfTheDay - 12) * 60;
};

const getMinutes = function(timeInMinutes, formatted = true) {
	const minutes = timeInMinutes % 1440 % 60;
	if (formatted && minutes < 10) {
		return minutes < 10 ? `0${minutes}` : `${minutes}`;
	}
	return minutes;
};

const getPeriod = function(timeInMinutes, formatted = true) {
	const hourOfTheDay = Math.floor(timeInMinutes % 1440 / 60);
	if (formatted) {
		return hourOfTheDay < 12 ? 'am' : 'pm';
	}
	return hourOfTheDay < 12 ? 0 : 720;
};

export { getDay, getHours, getMinutes, getPeriod };
